import React, { Component } from "react";

// Redux
import { connect } from "react-redux";

import { setToast } from "./../../../../redux/actions/toast";
import { removeDeniedLoans } from "./../../../../redux/actions/loans";

// Ajax Methods
import ajaxMethods from "../../../../api/ajax-methods";

// Ajax End Points
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { appInsights } from "../../../../config/appInsights";

class Deny extends Component {
  state = {
    comment: "",
  };

  onCommentChange = (e) => {
    this.setState({
      comment: e.target.value,
    });
  };

  // Deny Single Loan
  denyLoan = (e) => {
    e.preventDefault();
    const loans = e.target.dataset["id"];
    const { comment } = this.state;

    const payload = {
      mass_loan_id: loans,
      disapproval_tag: comment,
    };

    ajaxMethods
      .post(ajaxEndpoints.DENY_LOANS, payload)
      .then((response) => {
        if (response) {
          if (response.data.status === true) {
            // this.props.removeDeniedLoans(loans);
            this.props.setToast("success", response.data.message);
            this.props.onCloseModal();
          } else {
            this.props.setToast("warning", "Could not deny selected loans");
            this.props.onCloseModal();
          }
        } else {
          this.props.setToast("warning", "Could not deny selected loans");
          this.props.onCloseModal();
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "Deny.js",
          },
        });
        this.props.setToast("warning", error);
        this.props.onCloseModal();
      });
  };

  render() {
    // Get data from component props
    const {
      dataRecord: { loan_id },
      records,
    } = this.props;
    const { comment } = this.state;

    const {
      borrower_details: { first_name, last_name },
      loan_amount,
    } = records.find((record) => {
      return parseInt(record.loan_id) === parseInt(loan_id);
    });

    return (
      <div className="LoanModal Modal__content">
        <div className="Modal__body" style={{ overflow: "hidden" }}>
          {/* <h3 className="Modal__title p-b-1">Loan ID: <span>{loan_id}</span></h3> */}
          <h3 className="Modal__title p-b-1">Denial Summary</h3>
          {/* 2. Confirm Update Role Modal*/}
          <div id="update-role-confirm">
            <div className="m-b-30">
              <h5>Are you sure you want to deny the following loan? </h5>
              <p>Borrower Name: {`${first_name} ${last_name}`}</p>
              <p>Loan Amount: {loan_amount}</p>
              <form onSubmit={this.denyLoan}>
                <label style={{ width: "100%" }}>
                  Comment
                  <input
                    className="form-control"
                    value={comment}
                    onChange={this.onCommentChange}
                    placeholder="Reason for denying this loan"
                  />
                </label>
                <div className="Form__action-buttons m-t-2">
                  <button
                    type="submit"
                    data-mode="disburse"
                    data-id={loan_id}
                    onClick={this.denyLoan}
                    disabled={!comment}
                    className="btn zoom-element btn login-btn m-0 mr-auto"
                  >
                    <i className="fa fa-check-circle" /> Proceed
                  </button>
                  <button
                    type="button"
                    onClick={this.props.onCloseModal}
                    className="btn zoom-element btn login-btn m-0 ml-auto"
                  >
                    <i className="fa fa-times-circle" /> Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
          {/* 3. Updating Role Loader*/}
          <div
            id="update-role"
            style={{ display: "none" }}
            className=" loading-overlay speed-1x fadeInRight"
          >
            <div className=" form-loader form-loader-login verify">
              <div className="centerLoader">
                <div className="loading" id="adv-loader-alt" />
                <div className="center-txt webapp-ripple-text">
                  <i className="notifier fas fa-user-cog" />
                  Denying Loan Request ...
                </div>
              </div>
            </div>
          </div>

          {/* 4. Update Role Success Message*/}
          <div
            id="update-role-success"
            style={{ display: "none" }}
            className="loading-overlay speed-1x fadeInRight"
          >
            <div className="form-loader form-loader-login verify">
              <div className="centerLoader">
                <div className="loading success-loader">
                  <i className="webapp-ripple-notification success-text fa fa-check-circle" />
                </div>
                <div className="center-txt webapp-ripple-text">
                  <i className="notifier far fa-check-circle" />
                  Loan Request Denied
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    disbursements: { records },
  } = state.loansReducer;

  return {
    records,
  };
};

export default connect(mapStateToProps, { setToast, removeDeniedLoans })(Deny);
